import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { TeamMember } from '../team-member-dialog/team-member-dialog.component';

@Component({
  selector: 'app-team-member-item',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule
  ],
  templateUrl: './team-member-item.component.html',
  styleUrl: './team-member-item.component.css'
})
export class TeamMemberItemComponent {
  @Input() member!: TeamMember;
  @Input() index!: number;

  @Output() editMember = new EventEmitter<{ member: TeamMember; index: number }>();
  @Output() removeMember = new EventEmitter<number>();

  onEdit(): void {
    this.editMember.emit({ member: this.member, index: this.index });
  }

  onRemove(): void {
    this.removeMember.emit(this.index);
  }
}